import { Component, OnInit } from '@angular/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { send } from 'process';
import { AdminService } from './admin.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.sass']
})
export class AdminComponent implements OnInit {

allAdmin:any;
closeResult: string;
editAdminId:any;
adminName:any;
adminType="";
newPassword="";
confirmPassword="";
  constructor(private spinner:NgxSpinnerService,
              private tostr:ToastrService,
              private adminService:AdminService,
              private modalService: NgbModal,) { }

  ngOnInit(): void {
    this.getAdmin();
  }

  getAdmin(){
    this.spinner.show();
    let data = { "isDeleted" : 0 }
    this.adminService.getAdmin(data).subscribe((result:any)=>{
      console.log('get admin response  ',result);
      if(result.statusCode  == 200){
        this.spinner.hide()
          this.allAdmin=result.data;
      }else{
        this.spinner.hide()
        this.tostr.error(result.message);
      }
    })
  }


  updateAdmin(){
    if(this.newPassword == this.confirmPassword){
      this.spinner.show();
      var sendData;
      if(this.newPassword){
        sendData = {
          id : this.editAdminId,
          userName : this.adminName,      
          adminType:this.adminType,
          password : this.newPassword,
        }
      }else{
        sendData = {
          id : this.editAdminId,
          userName : this.adminName,     
          adminType:this.adminType, 
        }
      }
      this.adminService.updateAdmin(sendData).subscribe((result:any)=>{
        if(result.statusCode == 200){
          this.spinner.hide()
          this.tostr.success(result.message);
          this.modalService.dismissAll()
          this.getAdmin()
        }else{
          this.spinner.hide()
          this.tostr.error(result.message);
        }
      })
  
    }else{
        this.tostr.error("Password does not match")
    }

    
  }

  setActivationAdmin(value , data){
    this.spinner.show();
    let sendData = {
      id : data._id,
      active : value==true?1:0
    }
    console.log(sendData)
    this.adminService.updateAdmin(sendData).subscribe((result:any)=>{
      console.log('update admin res  ',result)
      if(result.statusCode == 200){
        this.spinner.hide();
        this.tostr.success(result.message);
      }else{
        this.spinner.hide();
        this.tostr.error(result.message);
      }
    })
  }

  deleteAdmin(data:any){
    this.spinner.show();
    let sendData = { 
      id : data._id,
      isDeleted : 1
    }
    this.adminService.updateAdmin(sendData).subscribe((result:any)=>{
      if(result.statusCode == 200){
        this.spinner.hide()
        this.tostr.success("Admin Deleted Successfully");
        this.getAdmin()
      }else{
        this.spinner.hide()
        this.tostr.error(result.message);
      }
    })
  }



  
  exportToExcel(){
    /* pass here the table id */
    let element = document.getElementById('excel-table');
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
 
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
 
    /* save to file */  
    XLSX.writeFile(wb, "Admin Report.xlsx");
   }


   adminAllData=[];
   exportToExcel_allData(){
//     this.spinner.show();
//     let data = { isDeleted : 2 }
//     this.adminService.getAdmin(data).subscribe((result:any)=>{
//       this.spinner.hide()
//       console.log('all admin excel data  ',result)
//       if(result.statusCode == 200){
//         this.spinner.hide();
//         for(let i=0; i<result.data.length; i++){
//             let temp = {
//               id : result.data[i].id,
//               userName:result.data[i].userName,
//               adminType : result.data[i].adminType,
//               activate : result.data[i].active,
//               isDeleted :  result.data[i].isDeleted
//             }
//             this.adminAllData.push(temp);
//     let workbook = new Workbook();
//     let worksheet = workbook.addWorksheet("Admin Data");
//     let header=["Id","Username" , "Admin Type" , "Active" , "IsDeleted"]
//     let headerRow = worksheet.addRow(header);
//     for (let x1 of  this.adminAllData)
// {
//   let x2=Object.keys(x1);
//   let temp=[]
//   for(let y of x2)
//   {
//     temp.push(x1[y])
//   }
//   worksheet.addRow(temp)
// }


// //add data and file name and download
// workbook.xlsx.writeBuffer().then((data) => {
//   let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
//   fs.saveAs(blob, "Admin Report "+'-'+new Date().valueOf()+'.xlsx');
// });
//         }
//         console.log(this.adminAllData)
      
//       }else{
//         this.tostr.error(result.message);
//         this.spinner.hide();
//       }
      
//     })

   }



  openModal(content , data) {
    this.modalService.open(content).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
    this.adminName = data.userName;
    this.adminType = data.adminType;
    this.editAdminId = data._id;
    this.newPassword="";
    this.confirmPassword="";
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

}
